
'use client';
import React from 'react';
import { motion } from 'framer-motion';
import Slider from 'components/slider';
import { detailProjects } from '../../data';
import Container from 'components/Container';

export default function PortfolioMobile() {
    return (
        <div className="lg:hidden">
            <Container>
                <h2 className="text-smoke text-5xl md:text-8xl xl:text-9xl  font-nebulica font-semibold mb-6"><span className="bg-lemone">PORT</span>FOLIO</h2>
            </Container>
            <Slider portfolios={detailProjects} showSmall={true}
                sliderClass="bg-transparent py-6 md:py-12"
                swiperClass="sliderHome"
            />
        </div>
    );
}

